export class EqualHeight {

  constructor() {
    this.itemDetail();
    this.itemReport();
    this.globalMatchHeight();
    this.gridItem();
    this.pagesPost();
  }

  itemDetail() {
    if ($('.item-detail .item .equal-height').length) {
      $('.item-detail .item .equal-height').matchHeight({byRow: false});
      $('.status .col-xs-3').matchHeight({byRow: false});
      $('.status .col-xs-4').matchHeight({byRow: false});
    }
  }

  itemReport() {
    if ($('.reports .grid-view').length) {
      $('.item h5').matchHeight();
      $('.item-data-container .state').matchHeight();
      $('.item-data-container .col').matchHeight();
    }
  }

  globalMatchHeight() {
    if ($('.match-height').length) {
      $('.match-height').matchHeight();
    }
  }

  gridItem() {
    if ($('.card-wrapper').length) {
      $('.card-wrapper').matchHeight();
    }
  }

  pagesPost() {
    if ($('.page .tertiary .equal-height.top').length) {
      $('.page .tertiary .equal-height.top').matchHeight();
    }
  }

};
